var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicOnWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_304364",
    "data-name": "Group 304364",
    transform: "translate(-524.166 -726.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18741",
    "data-name": "Group 18741",
    transform: "translate(524.166 726.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_193",
    "data-name": "Subtraction 193",
    d: "M5.977,2.074V7.527a1.978,1.978,0,1,1-3.954,0V2.074A1.979,1.979,0,1,1,5.977,2.074ZM4.46,11.7v2.329H5.931a.487.487,0,0,1,0,.971H2.069a.487.487,0,0,1,0-.971H3.54V11.7A4.126,4.126,0,0,1,0,7.527V6.993a.46.46,0,1,1,.92,0v.534A3.2,3.2,0,0,0,4,10.778,3.2,3.2,0,0,0,7.08,7.527V6.993a.46.46,0,1,1,.92,0v.534A4.126,4.126,0,0,1,4.46,11.7Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOnWhite);
export default __webpack_public_path__ + "static/media/MicOnWhite.81b9ce3500b9045a0dd0d4b8a31da21c.svg";
export { ForwardRef as ReactComponent };